import * as React from 'react';

import { Button, Flex, Input, Typography } from 'antd';

import { AntdRouterLink, PlusOutlinedIcon } from 'components';
import { PATHNAME } from 'utils';

const {
  DEFAULT: { SLUG_SEPARATOR: DEFAULT_SLUG_SEPARATOR },
  LOCAL: {
    DISCOUNT_CODES: { CREATE_URL: DISCOUNT_CODES_CREATE_URL },
  },
} = PATHNAME;

type DiscountCodesHeaderProps = {
  searchKey: string;
  handleSearchKey: (searchKey: string) => void;
};

const DiscountCodesHeader = ({
  searchKey,
  handleSearchKey,
  children,
}: React.PropsWithChildren<DiscountCodesHeaderProps>) => (
  <Flex
    gap='small'
    className='mb-5 max-xl:flex-col xl:items-center xl:justify-between'
  >
    <Typography.Title level={1} className='mb-0 text-lg'>
      کد تخفیف‌ها
    </Typography.Title>
    <Flex gap='small' className='max-xl:flex-wrap'>
      <Input.Search
        allowClear
        styles={{
          affixWrapper: {
            height: '2.5rem',
          },
        }}
        placeholder='جستجوی کد تخفیف‌ها'
        defaultValue={searchKey}
        onSearch={value => handleSearchKey(value)}
      />
      <React.Fragment>{children}</React.Fragment>
      <AntdRouterLink
        to={`${DISCOUNT_CODES_CREATE_URL}${DEFAULT_SLUG_SEPARATOR}`}
        className='max-xl:basis-full'
      >
        <Button type='primary' className='w-full' icon={<PlusOutlinedIcon />}>
          افزودن کد تخفیف
        </Button>
      </AntdRouterLink>
    </Flex>
  </Flex>
);

export { DiscountCodesHeader };
